<template>
	<div>
		<v-row class="align-center">
			<v-col cols="6" class="text-left">
				Total Serial : <strong>{{ serialStarPagination.total_data }}</strong>
			</v-col>
			<v-col cols="6" class="text-right">
				<v-btn depressed color="grey lighten-1" class="mr-2 white--text rounded-xl text-capitalize" @click="reset">Reset</v-btn>
				<v-btn depressed color="primary" class="white--text rounded-xl text-capitalize" @click="showSearch">Cari</v-btn>
			</v-col>
		</v-row>
		<div class="mt-3" v-if="!loading">
			<v-row class="ml-0" v-if="serialStarList.length > 0">
				<v-col cols="12" sm="6" md="4" xl="3" class="pl-0 pt-0" v-for="(serial, i) in serialStarList" :key="i">
					<v-card class="pa-3 elevation-0 rounded-xl hover-shadow" :color="(serial.serial_is_used == '1') ? '#f8f8f8' : ''">
						<v-row>
							<v-col cols="12" class="pb-0 px-2 text-right" v-if="false">
								<div class="px-4 py-1 white--text rounded-xl d-inline-block font-size-10 font-weight-bold" :class="serial.serial_serial_type_name == 'Basic' ? 'green' : 'amber'">{{ serial.serial_serial_type_name }}</div>
							</v-col>
							<v-col cols="6" class="pb-0">
								<div class="font-size-10 cl-grey">Serial</div>
								<div class="font-size-10 cl-primary font-weight-bold">{{ serial.serial_id }}</div>
							</v-col>
							<v-col cols="6" class="pb-0">
								<div class="font-size-10 cl-grey">Pin</div>
								<div class="font-size-10 cl-grey font-weight-bold">{{ serial.serial_pin }}</div>
							</v-col>
							<v-col cols="12" class="">
								<div class="font-size-10 cl-grey">Tanggal Pembelian</div>
								<div class="font-size-10 cl-grey font-weight-500">{{ serial.serial_buy_datetime | toDate }}</div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
			<div v-else>
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<v-card class="py-3 elevation-0 rounded-xl">
							<NoData></NoData>
							<div class="pt-3 text-center cl-secondary">Tidak ada data serial yang dapat ditampilkan</div>
						</v-card>
					</v-col>
				</v-row>
			</div>
		</div>
		<div v-if="loading">
			<v-row>
				<v-col cols="12" sm="12" md="12">
					<LoadData :loading="loading"></LoadData>
				</v-col>
			</v-row>
		</div>
		<div class="mt-3" v-if="serialStarList.length > 0">
			<v-row justify="end">
				<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
					<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="serialStarPagination.total_page" @input="changePage"></v-pagination>
				</v-col>
				<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
					<div class=" font-size-10">Menampilkan {{ serialStarPagination.total_display }} data dari total {{ serialStarPagination.total_data }} data</div>
				</v-col>
				<v-col cols="4" sm="2" md="1">
					<v-select :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" item-color="primary" @input="changeLimit"></v-select>
				</v-col>
			</v-row>
		</div>
		<ModalCari ref="modalCari" @action="cari"></ModalCari>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalCari from './components/ModalCari';

export default {
	components: {
		ModalCari
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '12',
			listLimit: [ '12', '20', '50', '100' ],
			params: [],
		}
	},
	computed: {
		...mapState('serial', ['serialStarList', 'serialStarPagination']),
	},
	methods: {
		...mapActions('serial', ['getSerialStarList']),

		showSearch() {
			this.$refs.modalCari.modalShow()
		},
		cari(data) {
			this.params = []
			this.page = 1

			if(data.serial.value)
				this.params.push(data.serial)

			if(data.isUsed.value)
				this.params.push(data.isUsed)

			if(data.dateBuy.value)
				this.params.push(data.dateBuy)

			if(data.dateUse.value)
				this.params.push(data.dateUse)

			this.getSerialStarList(this.queryString({limit:this.limit, page: this.page, params: this.params, sort: 'serial_buy_datetime', dir: 'asc'})).then(() => {
				this.$refs.modalCari.modalHide()
			})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		reset() {
			this.page = 1
			this.limit = '12'
			this.params = []
			this.getData()
			this.$refs.modalCari.reset()
		},
		getData() {
			this.loading = true
			this.getSerialStarList(this.queryString({limit:this.limit, page: this.page, params: this.params, sort: 'serial_buy_datetime', dir: 'asc'}))
				.then(() => {
					document.body.scrollTop = 0
					document.documentElement.scrollTop = 0
					this.loading = false
				})
		},
	},
	created(){
		this.getData()
	}
};
</script>

